import React, { useCallback, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { headers, url } from "../../utils/const";
import { PrintSalesReport } from "../../utils/print-service";
import PosNavigation from "../lotery/pos-navigation";
import Tickets from "../tickets/tickets";
import "./ventas.css";

const money = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

function Venta() {
  const [ventas, setVentas] = useState({
    betted: 0,
    winned: 0,
    paid: 0,
    balance: 0,
    deposito: 0,
    retiro: 0,
    balancePlayer: 0,
    total: 0,
    point: "",
    tickets: [],
  });
  const [formDate, setFormDate] = useState({ init: new Date(), end: new Date() });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [printing, setPrinting] = useState(false);
  const [printStatus, setPrintStatus] = useState("");

  const GetVentas = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${url}/run/venta`, {
        method: "post",
        headers,
        body: JSON.stringify(formDate),
      });
      const data = await response.json();
      if (!response.ok || !data || typeof data !== "object" || Array.isArray(data)) {
        throw new Error(
          typeof data === "string"
            ? data
            : data?.message || "No se pudo calcular el volumen de ventas"
        );
      }
      setVentas({
        ...data,
        tickets: Array.isArray(data.tickets) ? data.tickets : [],
      });
    } catch (cause) {
      setError(cause?.message || "No se pudo calcular el volumen de ventas");
    } finally {
      setLoading(false);
    }
  }, [formDate]);

  useEffect(() => {
    GetVentas();
  }, [GetVentas]);

  const stats = [
    { label: "Monto apostado", value: ventas.betted },
    { label: "Monto ganador", value: ventas.winned, tone: "is-negative" },
    { label: "Monto pagado", value: ventas.paid, tone: "is-negative" },
    { label: "Balance de venta", value: ventas.balance, tone: Number(ventas.balance) >= 0 ? "is-positive" : "is-negative" },
    { label: "Recargas", value: ventas.deposito },
    { label: "Retiros", value: ventas.retiro },
    { label: "Balance jugadores", value: ventas.balancePlayer },
    { label: "Total en caja", value: ventas.total, tone: "is-gold" },
  ];

  const reportPeriod = formDate.init.toLocaleDateString("es-ES") === formDate.end.toLocaleDateString("es-ES")
    ? `Fecha: ${formDate.init.toLocaleDateString("es-ES")} Hora: ${new Date().toLocaleTimeString("es-ES")}`
    : `${formDate.init.toLocaleDateString("es-ES")} al ${formDate.end.toLocaleDateString("es-ES")}`;

  const printReport = async () => {
    setPrinting(true);
    setPrintStatus("Enviando reporte al servidor de impresión...");
    try {
      const result = await PrintSalesReport({
        ...ventas,
        date: reportPeriod,
      });
      if (!result.printed) {
        throw new Error(result.detail || result.reason || "Servidor de impresión no disponible");
      }
      setPrintStatus(
        result.protocol === "legacy"
          ? "Reporte enviado al servidor de impresión."
          : "Reporte impreso correctamente."
      );
    } catch (cause) {
      setPrintStatus(`No se pudo imprimir el reporte: ${cause?.message || "servidor no disponible"}.`);
    } finally {
      setPrinting(false);
    }
  };

  return (
    <div className="queen-pos-page">
      <div className="queen-pos reina-section-shell">
        <PosNavigation active="venta" />

        <main className="reina-section-main noPrint">
          <section className="reina-panel">
            <div className="reina-page-heading">
              <div>
                <span className="reina-eyebrow">Control del punto</span>
                <h2>Volumen de ventas</h2>
                <p>Consulta el cuadre del período, revisa los totales y accede al historial de tickets.</p>
              </div>
              {ventas.point && <span className="reina-badge is-active">{ventas.point}</span>}
            </div>

            <div className="reina-filter-grid">
              <div className="reina-field">
                <label htmlFor="venta-fecha-inicio">Desde</label>
                <DatePicker
                  id="venta-fecha-inicio"
                  className="form-control"
                  selected={formDate.init}
                  onChange={(date) => date && setFormDate((value) => ({ ...value, init: date }))}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              <div className="reina-field">
                <label htmlFor="venta-fecha-fin">Hasta</label>
                <DatePicker
                  id="venta-fecha-fin"
                  className="form-control"
                  selected={formDate.end}
                  onChange={(date) => date && setFormDate((value) => ({ ...value, end: date }))}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              <button type="button" className="reina-btn reina-btn-primary" onClick={GetVentas} disabled={loading}>
                {loading ? "Actualizando..." : "Actualizar cuadre"}
              </button>
            </div>
          </section>

          {error && <div className="reina-status is-error" role="alert">{error}</div>}
          {loading && !error && <div className="reina-status" role="status">Actualizando cuadre...</div>}
          {printStatus && <div className="reina-status" role="status">{printStatus}</div>}

          <section className="reina-stat-grid" aria-label="Resumen de ventas">
            {stats.map((stat) => (
              <article key={stat.label} className={`reina-stat ${stat.tone || ""}`}>
                <span>{stat.label}</span>
                <strong>RD$ {money(stat.value)}</strong>
              </article>
            ))}
          </section>

          <section className="reina-panel reina-action-row">
            <p>{ventas.tickets.length} ticket{ventas.tickets.length === 1 ? "" : "s"} en el período seleccionado.</p>
            <div className="reina-action-buttons">
              <button type="button" className="reina-btn reina-btn-gold" onClick={printReport} disabled={printing}>
                {printing ? "Enviando..." : "Imprimir reporte"}
              </button>
              {ventas.tickets.length > 0 && <Tickets tickets={ventas.tickets} />}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default Venta;
